<div class="flex grid-gap-10 style2023" style="margin-bottom: 12px" *ngIf="!isBusy">
  <div class="flex-grow-1">
    <p-dropdown
      [options]="depts"
      appendTo="body"
      placeholder="Select Department"
      class="filter-dropdown ui-dropdown-narrow"
      [(ngModel)]="selectedDept"
      (ngModelChange)="onSelectDept($event)"
    ></p-dropdown>
  </div>

  <div class="flex-grow-1">
    <p-dropdown
      [options]="teams"
      appendTo="body"
      placeholder="Select Team"
      class="filter-dropdown ui-dropdown-narrow"
      [(ngModel)]="selectedTeam"
      (ngModelChange)="onSelectTeam($event)"
    ></p-dropdown>
  </div>

  <div class="flex-grow-1">
    <p-dropdown
      [options]="users"
      appendTo="body"
      placeholder="Select User"
      class="filter-dropdown ui-dropdown-narrow"
      [(ngModel)]="selectedUser"
      (ngModelChange)="onSelectUser($event)"
    ></p-dropdown>
  </div>

  <div class="flex-shrink-1">
    <button
      pButton
      type="button"
      icon="fa ui-icon-restore"
      class="button-style btn-sm ui-tertiary-button ml-2"
      (click)="resetFilters()"
    ></button>
  </div>
</div>
